<template>
  <div class="spm-tooltip hidden-xs">
    <img src="@/assets/images/info.svg" />
    <div class="spm-tooltip-content-container" :class="cssClass">
      <div class="spm-tooltip-content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tooltip",
  props: {
    cssClass: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";
@import "@/assets/styles/_mixins.scss";

$tooltipImageSize: 1.75rem;
$padding: 0.5rem;
$tooltipWidth: 400px;

.spm-tooltip {
  position: relative;
  z-index: 500;
  width: $tooltipImageSize;
  height: $tooltipImageSize;
  border-radius: calc($tooltipImageSize / 2);
  padding: $padding;
  margin-left: 0.5rem;
  margin-top: -0.5rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  @include shadow(100%);

  &:has(.visible-xs) {
    display: inline-flex !important;
  }

  img {
    max-width: 100%;
    max-height: 100%;
  }

  .spm-tooltip-content-container {
    position: absolute;
    display: block;
    z-index: 1000;
    visibility: hidden;
    width: $tooltipWidth;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &.top {
      bottom: calc(100% + 2 * $padding);
      left: 50%;
      margin-left: calc(($tooltipWidth / 2) * -1);
    }

    &.right {
      top: -5px;
      left: calc(100% + 2 * $padding);
    }

    .spm-tooltip-content {
      display: inline-block;
      width: auto;
      max-width: 100%;
      font: normal 16px "csr";
      text-align: center;
      padding: 0.5rem;
      border-radius: 10px;
      color: $secondary;
      background-color: white;
      @include shadow(5px);
    }
  }

  &:hover {
    .spm-tooltip-content-container {
      visibility: visible;
      z-index: 1000;
    }
  }

  @media (max-width: $screen-xs-max) {
    $tooltipImageSize: 1.2rem;
    $padding: 0.25rem;
    $tooltipWidth: 350px;

    width: $tooltipImageSize;
    height: $tooltipImageSize;
    border-radius: calc($tooltipImageSize / 2);
    padding: $padding;
    margin-left: 0.25rem;

    .spm-tooltip-content-container {
      width: $tooltipWidth;

      &.top {
        bottom: calc(100% + 2 * $padding);
        left: 50%;
        margin-left: calc(($tooltipWidth / 2) * -1 - 0.5rem);
      }

      &.right {
        top: -5px;
        left: calc(100% + 2 * $padding);
      }

      .spm-tooltip-content {
        font: normal normal normal 13px/16px "csr";
      }
    }
  }
}
</style>
